var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('pre',[_vm._v("垂直排列且底部参差不齐")]),_c('div',{staticClass:"masonry"},_vm._l((30),function(item){return _c('v-card',{key:item,attrs:{"id":item,"color":"primary"}},[_vm._v(" "+_vm._s(item)+" ")])}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }